import { VariantProps } from "class-variance-authority";
import { EllipsisVerticalIcon } from "lucide-react";
import React, { memo } from "react";

import { Button, buttonVariants } from "../button";
import { DropdownMenu } from "../DropdownMenu";
import { BasicTooltip } from "../Tooltip";

import { ActionsProps } from "./types";

export const Actions: React.FC<ActionsProps> = memo(({ actions, dropdownActions }) => (
  <div className="flex items-center justify-center gap-x-2">
    {actions?.map((action, index) =>
      React.isValidElement(action) ? (
        // eslint-disable-next-line react/no-array-index-key
        React.cloneElement(action, { key: `action-${index}` })
      ) : (
        <BasicTooltip
          // eslint-disable-next-line react/no-array-index-key
          key={`action-${(action as { label: string })?.label}-${index}`}
          content={(action as { tooltipContent?: string })?.tooltipContent ?? ""}
          shouldShow={Boolean((action as { tooltipContent?: string })?.tooltipContent)}
        >
          <span>
            <Button
              onClick={(action as { onClick: () => void })?.onClick}
              variant={
                (action as { variant?: VariantProps<typeof buttonVariants>["variant"] })?.variant ||
                ("outline" as VariantProps<typeof buttonVariants>["variant"])
              }
              size="sm"
              className="inline-flex items-center"
              disabled={(action as { disabled?: boolean })?.disabled ?? false}
            >
              {(action as { icon?: React.ReactNode })?.icon}
              <span className="hidden sm:inline">{(action as { label: string })?.label}</span>
            </Button>
          </span>
        </BasicTooltip>
      ),
    )}
    {dropdownActions && dropdownActions.filter(d => d.shouldShow).length > 0 && (
      <DropdownMenu
        icon={<EllipsisVerticalIcon className="h-4 w-4" />}
        menuItems={dropdownActions}
      />
    )}
  </div>
));
